
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 66 66","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_4769_41678)"}},[_c('circle',{attrs:{"cx":"33","cy":"33","r":"17","transform":"rotate(-180 33 33)","fill":"#0073BE"}})]),_c('path',{attrs:{"d":"M32.929 40V26.036m0 0L39 32.107m-6.071-6.071l-6.072 6.071","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_4769_41678","x":"0","y":"0","width":"66","height":"66","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"8"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_4769_41678"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_4769_41678","result":"shape"}})])])])
          )
        }
      }
    